<template>
  <div class="produceInformationHead table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      生產資訊
    </li>
    <b-table
      :items="produceInformationHeadItem"
      :fields="produceInformationHeadFields"
      class="text-center produceInformationHead-table-detail"
    >
      <template #head(item_title)="">
        <div class="produceInformationHead-table-line">
          <span class="produceInformationHead-table-item">項目</span>
          <span class="produceInformationHead-table-status">狀態</span>
        </div>
      </template>
      <template #cell(qty)="row" style="">
        {{ row.item["qty"].name }}:
        {{
          isNaN(Number(row.item["qty"].count))
            ? row.item["qty"].count
            : Number(row.item["qty"].count).toLocaleString("en-US")
        }}
      </template>
      <template #cell(standard_total_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
      <template #cell(material_total_weight)="data">
        {{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}
      </template>
      <!-- {{ (398000).toLocaleString("en-US") }} -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "produceInformationHead",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      produceInformationHeadFields:
        "produceInformationHead/get_produceInformationHeadFields",
      produceInformationHeadItem:
        "produceInformationHead/get_produceInformationHeadItem",
    }),
  },
};
</script>

<style lang="scss">
.produceInformationHead-table-line {
  border-top: 2.8rem #cccccc solid; /*上邊框寬度等於表格第一行行高*/
  width: 0px; /*讓容器寬度為0*/
  height: 0px; /*讓容器高度為0*/
  border-left: 5rem #bdbdbd solid; /*左邊框寬度等於表格第一行第一格寬度*/
  position: relative; /*讓裡面的兩個子容器絕對定位*/
  color: #000000;
}
.produceInformationHead-table-item {
  font-style: normal;
  display: block;
  position: absolute;
  top: -43px;
  left: -40px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}
.produceInformationHead-table-status {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  left: -85px;
  width: 2.8rem;
  font-family: "dfyuanstd-w5";
}

.produceInformationHead-table-detail thead th {
  border-top: 1px solid;
}
.produceInformationHead-table-detail th,
.produceInformationHead-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.produceInformationHead-table-detail th:first-child,
.produceInformationHead-table-detail td:first-child {
  border-left: 1px solid;
}
.produceInformationHead-table-detail {
  margin-bottom: 0px;
}
.produceInformationHead-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(1) {
  width: 5rem;
  min-width: 5rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(2) {
  min-width: 10rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(3) {
  min-width: 5rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(4) {
  min-width: 8rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(5) {
  min-width: 10rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(6) {
  min-width: 10rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(7) {
  min-width: 5rem;
}
.produceInformationHead-table-detail thead tr:last-child th:nth-child(8) {
  min-width: 5rem;
}
.produceInformationHead-table-detail tr td {
  background-color: #ffffff;
}
.produceInformationHead-table-detail tr td:nth-child(1) {
  background-color: #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/produceInformationHead.vue